import {graphql, useStaticQuery} from 'gatsby';

const useTheVisionPageImages = (props) => {
  const query = useStaticQuery(graphql`
      {
          allFile(filter: {relativeDirectory: {eq: "pages/the-vision"}}) {
              nodes {
                  name
                  childImageSharp {
                      gatsbyImageData(
                          quality: 70
                          placeholder: NONE
                          layout: FULL_WIDTH
                          formats: [AUTO, WEBP, AVIF]
                          webpOptions: {quality: 70}
                      )
                  }
              }
          }
      }
  `);

  const image = query.allFile.nodes.filter(fileImage => fileImage.name === props.name);

  return image && image.length > 0 ? image[0].childImageSharp.gatsbyImageData : null;
};

export default useTheVisionPageImages;
